var React = require('react');

function VoicemailLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.21 32.357a8.179 8.179 0 100-16.358 8.179 8.179 0 000 16.358zm0 2c5.621 0 10.178-4.558 10.178-10.179S15.831 14 10.21 14 .032 18.557.032 24.178 4.589 34.356 10.21 34.356zm27.644-2a8.179 8.179 0 100-16.358 8.179 8.179 0 000 16.358zm0 2c5.621 0 10.178-4.558 10.178-10.179S43.475 14 37.854 14s-10.178 4.557-10.178 10.178 4.557 10.178 10.178 10.178z","key":0}),React.createElement("path",{"d":"M10.092 32.448H38.02v1.908H10.092v-1.908z","key":1})]);
}

VoicemailLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = VoicemailLight;

VoicemailLight.default = VoicemailLight;
